import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Json = any;

export interface SiteEntry {
  page: string;
  section: string;
  item_key: string;
  sort_order: number;
  data: Record<string, Json>;
  image_url: string | null;
}

/** Public read of all published content. Safe for anonymous SSR/prerender. */
export const getSiteContent = createServerFn({ method: "GET" }).handler(
  async (): Promise<SiteEntry[]> => {
    const supabase = createClient<Database>(
      process.env.SUPABASE_URL!,
      process.env.SUPABASE_PUBLISHABLE_KEY!,
      { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
    );

    const { data, error } = await supabase
      .from("content_entries")
      .select("page, section, item_key, sort_order, data, image_url")
      .eq("is_published", true)
      .order("sort_order", { ascending: true });

    if (error) {
      console.error("getSiteContent error:", error.message);
      return [];
    }
    return (data ?? []) as SiteEntry[];
  },
);
